import PropTypes from 'prop-types';
import { ReactComponent as IconClose } from '../../public/images/svg/icon_close.svg';
import Button from '../Button/Button';

const ActionDrawer = ({ isOpen = false, children, onClick }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      data-testid="action-drawer"
      className={
        'fixed overflow-hidden z-50 inset-0 transform ease-in-out ' +
        (isOpen
          ? ' max-w-full duration-300 translate-x-0  '
          : ' max-w-[4.5rem] transition-all -translate-x-0  ')
      }
    >
      <div
        className={
          'w-screen left-0 absolute bg-grey-100 border-grey-200 border-l border-solid h-full duration-300 ease-in-out transition-all transform  ' +
          (isOpen ? ' max-w-lg translate-x-action-drawer ' : ' max-w-0 translate-x-full ')
        }
      >
        <div className="relative w-screen max-w-lg flex flex-col justify-between space-y-6 pt-20 pb-10 overflow-y-auto overflow-x-hidden h-full no-scrollbar">
          <div
            className={
              'h-screen p-4 pr-6 flex flex-col transition-all transform duration-300' +
              (isOpen ? ' w-full' : ' w-16 ')
            }
          >
            <Button
              dataTest="action-drawer-close-button"
              name="action-drawerOpenMenu"
              className="bg-transparent block self-end"
              onClick={onClick}
              icon={<IconClose />}
            />

            <div
              data-testid="action-drawer-children"
              className="grow overflow-y-scroll no-scrollbar"
            >
              {children}
            </div>
          </div>
        </div>
      </div>

      <div
        className="w-screen h-screen cursor-pointer"
        data-testid="action-drawer-background-overlay"
        onClick={onClick}
      />
    </div>
  );
};

ActionDrawer.propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func
};

export default ActionDrawer;
